import { useModalsContext } from 'modules/sendingPlatforms/contexts';
import { Send24, Delete24 } from 'ui/icons';
import { BUTTON_SIZES } from 'ui/button';
import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import noop from 'utils/noop';

export const ApplicationOverflowMenu = () => {
  const { showSendTestPushModal } = useModalsContext();

  const options = [
    {
      id: 'send-test-push',
      label: 'Send test push',
      content: (
        <>
          <Send24 />
          Send test push
        </>
      ),
      onClick: showSendTestPushModal,
      as: AllowedActionMenuElements.Button,
    },
    {
      id: 'delete-application',
      label: 'Delete',
      content: (
        <>
          <Delete24 />
          Delete
        </>
      ),
      onClick: noop,
      as: AllowedActionMenuElements.Button,
    },
  ];

  return (
    <OverflowMenu id="application-overflow-menu" options={options} size={BUTTON_SIZES.SMALL} />
  );
};
